<template>
  <div class=" page no-top-bar have-menu">
        <div class="bg-custom-blue pt-8" :class="isLogin ? 'pb-10' : 'pb-14'">
            <div class="flex flex-col justify-center items-center" @click="viewProfle()">
                <div class="w-11 h-11">
                    <img v-if="isLogin" class="w-full h-full" src="@/assets/icon/ic-user.svg" alt="">
                    <img v-else class="w-full h-full" src="@/assets/icon/ic-lock.svg" alt="">
                </div>
                <div v-if="isLogin" class="flex flex-col justify-center items-center mt-6">
                    <div class="border rounded flex justify-center items-center
                                text-20 text-white px-4 mt-2.5 custom-max-h custom-color"
                    >
                            {{getLevelText()}}
                    </div>
                    <div class="mt-2.5 text-white text-26">
                        {{displayName}}
                    </div>
                </div>
                <div v-else class="flex justify-center items-center
                            text-26 text-white px-4 mt-5"
                    v-html="lbl.profile.text_login"
                >
                </div>
            </div>
        </div>
        <div class="page-content flex flex-col justify-between">
            <div v-if="isLogin" class="mx-auto custom-size-img relative">
                <img class="w-full h-full" src="@/assets/icon/ic-rectangle.svg" alt="">
                <div class="point-text-postion w-full">
                    <div class="flex justify-center items-center text-26 text-green-1 font-bold">
                        <span>คุณมี &nbsp;</span>
                        <span>{{userPoints}}&nbsp;</span>
                        <span>คะแนน</span>
                    </div>
                </div>
            </div>
            <div v-else class="custom-position relative mx-7">
               <button class="border border-green-1 rounded-full
                        text-white bg-green-1 w-full py-2.5 text-22 font-bold"
                        @click="gotoLogin($event)"
                        >
                {{lbl.profile.login}}
               </button>
            </div>
            <div class="grid grid-cols-3 gap-4 px-4 mt-10">
                <template v-if="isLogin">
                    <GoToPageItem
                        :label="lbl.profile.text_page.my_medal"

                        @click="gotoPage('/badge')"
                    >
                        <img src="@/assets/icon/ic-medal.svg" alt="">
                    </GoToPageItem>
                    <GoToPageItem
                        :label="lbl.profile.text_page.history"
                        @click="gotoPage('/history')"
                    >
                        <img src="@/assets/icon/ic-history.svg" alt="">
                    </GoToPageItem>
                    <GoToPageItem
                        :label="lbl.profile.text_page.helpchat"
                        @click="gotoPage('/helpchat')"
                    >
                        <img src="@/assets/icon/ic-mobile-help.svg" alt="">
                    </GoToPageItem>
                </template>
                <GoToPageItem
                    :label="lbl.profile.text_page.faq"
                    @click="gotoPage('/faq')"

                >
                    <img src="@/assets/icon/ic-faq.svg" alt="">
                </GoToPageItem>
                <GoToPageItem
                    :label="lbl.profile.text_page.contactus"
                    @click="gotoPage('/contactus')"
                >
                    <img src="@/assets/icon/ic-contact-us.svg" alt="">
                </GoToPageItem>
                <GoToPageItem
                    :label="lbl.profile.text_page.privacy"
                    @click="gotoPage('/privacy')"
                >
                    <img src="@/assets/icon/ic-privacy.svg" alt="">
                </GoToPageItem>
                <GoToPageItem
                    :label="lbl.profile.text_page.terms"
                    @click="gotoPage('/terms')"
                >
                    <img src="@/assets/icon/ic-term.svg" alt="">
                </GoToPageItem>
                <GoToPageItem
                    :label="lbl.profile.text_page.personal_data_policy"
                    @click="gotoConsentExternal()"
                >
                    <img src="@/assets/icon/ic-term.svg" alt="">
                </GoToPageItem>
            </div>
        </div>
        <MenuBar
            :modalController="modalController"
        ></MenuBar>
        <ModalMaster :controller="modalController"></ModalMaster>
  </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager";
// helper
import { StaticLevel,UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin.js";
import AuthPageMixin from "@/mixin/AuthPageMixin";
import GoToPageItem from "../component/GoToPageItem.vue";
import MenuBar from "@/components/Layout/MenuBar/MenuBar.vue"
export default {
    name: "Other",
    mixins: [AuthStatusMixin, LocaleMixin, ModalMixin, AuthPageMixin],
    components: {
        GoToPageItem,
        MenuBar,
    },
    data: function() {
        return {
            isHasData: false,
            formData: null,

            displayName: null,
            userPoints: null,
        };
    },
    created: function() {
        this.tracking.screenName('other');
        this.tracking.event('other', 'view_profile');
    },
    methods: {
        //#region mixin function
        onAccountInit: function () {
            this.formData = this.profileCustom;

            let profile = this.profile;
            if (profile) {
                this.userPoints = profile.updated_points.points
            }
            if (this.formData != null) {
                this.isHasData = true;
                this.displayName = this.formData.firstName + ' ' + this.formData.lastName;
            }
        },
        //#endregion mixin function
        viewProfle: function () {
            if (!this.isLogin)
                return;

            let level = this.checkLevelVerifiedlaserno();
            if (!level) {
                this.modalController.confirmModal
                                    .clearModal()
                                    .setTag('verifiedlaserno')
                                    .setMsg(this.lbl.verify_laser_id.before_redeem)
                                    .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                    window.location.replace(url);
                });
            } else {
                this.tracking.event('other', 'click_profile');

                this.$router.push("/profile");
            }


        },
        getLevelText: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                return this.userLevel.getLevelName(this.level);
            } else {
                return "";
            }

        },
        checkLevelVerifiedlaserno: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                return this.userLevel.getLevelVerifiedlaserno();
            } else {
                return "";
            }
        },
        gotoLogin: function () {
            let url = ConfigManager.getWebSofinUrl();
            window.location.replace(url);
        },
        gotoPage: function (router) {
            if(router == '/badge') {
                this.tracking.event('other', 'click_badge');
            } else if(router == '/history'){
                this.tracking.event('other', 'click_history');
            } else if(router == '/helpchat'){
                this.tracking.event('other', 'click_online_survey');
            } else if(router == '/faq'){
                this.tracking.event('other', 'click_faq');
            } else if(router == '/contactus'){
                this.tracking.event('other', 'click_contact_us');
            } else if(router == '/terms'){
                this.tracking.event('other', 'click_term');
            } else if(router == '/privacy'){
                this.tracking.event('other', 'click_privacy');
            }
            this.$router.push(router);
        },
        gotoConsentExternal: function () {
            this.tracking.event('other', 'click_consent');
            let url = `${ConfigManager.getWebSofinUrl()}/editconsent?return_url=other`
            this.tracking.screenName('consent');
            this.tracking.event('consent', 'view_consent');
            window.location.replace(url);
        }
    },
}
</script>
<style lang="scss" scoped>
    .page {
        .bg-custom-blue {
            background-image: url(../../../assets/bg/bg-splus-blue.png);
            background-size: 100% 100%;
            background-position: center center;
        }
        .custom-position {
            margin-top: -25px;
        }
        .custom-size-img {
            max-width: 272px;
            margin-top: -25px;
        }
        .custom-max-h {
            height: 22.5px;
        }
        .custom-color {
            background-color: rgba(255, 255, 255, 0.2);
        }
        .point-text-postion {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
